import SnowPeakLogo from 'images/Snow Peak Logo.png'
import useCurrentWeather from 'components/common/useCurrentWeather'
import { MainContainer, LogoImage, Title, Subtitle, WeatherText } from './homeMainLogo_styles'

const HomeMainLogo = () => {
  const currentWeather = useCurrentWeather()

  return (
    <MainContainer>
      <LogoImage src={SnowPeakLogo} alt='snow peak logo' />
      <Title>CAMPFIELD</Title>
      <Subtitle>Long Beach</Subtitle>
      <WeatherText>{currentWeather}</WeatherText>
    </MainContainer>
  )
}

export default HomeMainLogo
